<template>
  <div class="c-store-summary u-padding-top-small u-padding-bottom-small u-padding-right-tiny">
    <div class="o-layout o-layout--small o-layout--middle">
      <div class="o-layout__item u-1/8 u-align-center">
        <a class="c-store-summary__distance" v-on:click="showOnMap(store)">
          <svg class="c-icon">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-pin"></use>
          </svg>
          {{ roundedDistance }} km
        </a>
      </div>
      <div class="o-layout__item u-4/8">
        <div class="u-h4 c-store-summary__title">
          <a class="c-store-summary__link" :href="url">{{ name }}</a>
        </div>
        <div class="c-store-summary__address u-small">
          {{ address }}
          <br>
          {{ postcode }} {{ city }}
        </div>
      </div>
      <div class="o-layout__item u-3/8">
        <button
          class="c-button c-button--secondary c-button--small c-button--stretch c-button--ghost u-margin-bottom-tiny"
          v-on:click="showOnMap(store)"
        >
          <span class="c-button__label">Voir sur la carte</span>
        </button>
        <a
          :href="url"
          class="c-button c-button--secondary c-button--small c-button--stretch c-button--ghost"
        >
          <span class="c-button__label">Informations</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import roundTo from 'round-to'

  export default {
    props: [
      'store',
    ],
    computed: {
      id () {
        return this.store.ID
      },
      name () {
        return this.store.post_title
      },
      address () {
        return this.store.store_address
      },
      postcode () {
        return this.store.store_postcode
      },
      city () {
        return this.store.store_city
      },
      phone () {
        return this.store.store_phone
      },
      roundedDistance () {
        return roundTo(this.store.distance, 1)
      },
      url () {
        return this.store.url
      },
    },
    methods: {
      showOnMap (store) {
        this.$store.dispatch('selectStore', store)
      },
    }
  }
</script>
